/* @flow */

import DealerActivityTypes from "./DealerActivityTypes";
import DealerProductGroupTypes from "./DealerProductGroupTypes";
import HereMapsThemes from "../components/MapProviders/HereMaps/HereMapsThemes";
import HereMapsLanguages from "../components/MapProviders/HereMaps/HereMapsLanguages";
import { DISTANCE_UNIT_KM } from "./DistanceUnits";

export default {
  DEALER_DYNAMIC_FIELD_PREFIX_ACTIVITY_TYPE: "dealer.activityType.",
  DEALER_DYNAMIC_FIELD_PREFIX_PRODUCT_GROUP: "dealer.productGroup.",
  DEFAULT_DEALER_BRAND_CODE: "MB",
  DEFAULT_DEALER_PRODUCT_GROUP: "PASSENGER-CAR",
  DEFAULT_DEALER_ADDRESS_PLACEHOLDER_LINE_1: "{line1}",
  DEFAULT_DEALER_ADDRESS_PLACEHOLDER_LINE_2: "{zipcode} {city}",
  DEFAULT_DEALERS_SEARCH_COUNT: 2000,
  DEFAULT_DEALERS_SEARCH_RADIUS: 20,
  DEFAULT_DEALERS_PAGINATION_PAGE_SIZE: 10,
  DEFAULT_DISTANCE_UNIT: DISTANCE_UNIT_KM,
  DEFAULT_DISTANCE_DELIMITER: ",",
  DEFAULT_HERE_MAPS_LANGUAGE: HereMapsLanguages.eng,
  DEFAULT_HERE_MAPS_THEME: HereMapsThemes.THEME_NORMAL_DAY_GREY,
  DEFAULT_HERE_MAPS_ZOOM: 15,
  DEFAULT_VERSION: "0.0.0",
  DEFAULT_SORT_PROPERTY: "airDistance",
  DEFAULT_MARKET_PROPERTY_SPA_FILTERING_ACTIVITY_TYPES: [
    DealerActivityTypes.PARTS,
    DealerActivityTypes.SALES,
    DealerActivityTypes.SERVICE,
    DealerActivityTypes.USED_VEHICLES_TRADE,
  ],
  DEFAULT_MARKET_PROPERTY_SPA_FILTERING_PRODUCT_GROUPS: [
    DealerProductGroupTypes.PASSENGER_CAR,
  ],
  HERE_MAPS_TILES_URL: {
    WORLD_WIDE: "https://{serverIndex}.base.maps.ls.hereapi.com",
    KR_CIT: "https://{serverIndex}.base.maps.cit.api.heremaps.kr",
    KR_PROD: "https://{serverIndex}.base.maps.api.heremaps.kr",
    JP: {
      URL: "https://js.api.here.com/v3/3.1/styles/omv/oslo/japan/",
      PATH: "v2/vectortiles/core/mc",
      API_KEY: "sh7d1MeivwkSX2NdzP4p7VJqV8-SPGY6fJgJhG7PSd8",
    },
  },
  HERE_MAPS_ROUTING_URL: "https://wego.here.com/directions/mix",
  MOBILE_ROUTING_URL: {
    GOOGLE_MAPS: "https://maps.google.com",
    APPLE_MAPS: "https://maps.apple.com",
  },
  MAPS_LEFT_PANEL_OFFSET: 24,
  MAPS_PADDING_DEFAULT: 40,
  MAPS_PADDING_LEFT: {
    MQ6: 502,
    MQ4: 443,
  },
  MAPS_GESTURES_ZOOM_TOUCH_LABEL: "Use two fingers to move the map",
  MAPS_GESTURES_ZOOM_SCROLL_LABEL: "Use [ CTRL + scroll ] to zoom the map",
  MAPS_GESTURES_ZOOM_SCROLL_MAC_LABEL:
    "Use [ \u2318 + scroll ] to zoom the map",
  SEARCH_NO_SUGGESTIONS:
    "No Dealers found. Do you want Mercedes-Benz to use your " +
    "location to search for the nearest Dealer? Click below.",
  PACKAGE_DSW: "@daimler/oneweb-dlc-selector-widget",
  PACKAGE_DDW: "@daimler/oneweb-dlc-display-widget",
  PACKAGE_SPA: "@daimler/oneweb-dlc-spa",
  TPL_GENERIC_PREFIX: "generic.",
  TPL_DEFAULT_PREFIX: "default.",
  TPL_LANGUAGE_ACTIVITY_TYPE_PREFIX: "default.activity.",
  TPL_LANGUAGE_ACTIVITY_TYPE_GROUP_PREFIX:
    "default.activity.activity-types-group-",
  TPL_LANGUAGE_ACTIVITY_TYPE_POSTFIX: ".label",
  TPL_LANGUAGE_PRODUCT_GROUP_PREFIX: "default.productGroup.",
  TPL_LANGUAGE_PRODUCT_GROUP_POSTFIX: ".label",
  TPL_LANGUAGE_HIGHLIGHT_PREFIX: "oneDLC.highlights.",
  TPL_LANGUAGE_WEEKDAY_PREFIX: "default.weekday.",
  TPL_LANGUAGE_WEEKDAY_POSTFIX: ".label",
  WIDGET_FIELD_DEALER_PREFIX: "dealer",
  UNSUPPORTED_BROWSER_WARNING:
    "You are currently using an obsolete web browser " +
    "(Internet Explorer 11 or older), which is no longer supported for technical reasons. " +
    "In order to use Dealer Locator, please use a current browser, such as Microsoft Edge, " +
    "Google Chrome, Safari or Firefox.",
  LOCAL_PHONE_NUMBER_BY_MARKET: {
    JP: {
      localNumber: "+81",
      localNumberReplacement: "0",
    },
    PT: {
      localNumber: "+351",
      localNumberReplacement: "",
    },
  },
};
